export const Hints_content = [
    {
        name: 'UserDashboard',
        path: '/dashboard',
        content: [
            {
                header: 'Dashboard Overview',
                description: `Upon logging in, you will be directed to your dashboard's homepage. Here, you'll find an overview of your counter, active shipments and quick links to different dashboard sections.`
            },
            {
                header: 'Dashboard Counter ',
                points: [{
                    steps: [
                        {
                            description: `Number of Active Shipments (Incoming/ Outgoing)
                        This displays the total number of the active shipments you currently have ongoing. When clicked upon a dropdown list which shows the numbers for outgoing and incoming active shipments are displayed respectively.
                        `
                        },
                        {
                            description: `Number of  Scheduled Shipments
                        This displays the total number of shipments that have been scheduled for delivery                        
                        `
                        },
                        {
                            description: `Number of Quotes
                        This display the number of quotes you have received`
                        }
                    ]
                }]
            },
            {
                header: 'Dashboard Icons',
                points: [
                    {
                        title: "a) Book Shipment",
                        steps: [
                            {
                                description: `From the dashboard homepage, click on the "Book Shipment" button`
                            },
                            {
                                description: `A modal with to select if you want to book the shipment “ForSelf” or “For Others`
                            },
                            {
                                description: `Select your preferred option `
                            },
                            {
                                description: `Fill the Senders contact and delivery information`
                            },
                            {
                                description: `Fill the receivers contact and delivery information`
                            },
                            {
                                description: `Select your preferred shipment type`
                            },
                            {
                                description: `Choose your preferred shipment service method`
                            },
                            {
                                description: `Select preferred mode of payment`
                            },
                            {
                                description: `Review the shipping details and confirm the shipment.`
                            }
                        ]
                    },
                    {
                        title: "b) Track Shipments",
                        steps: [
                            {
                                description: `Navigate to the "Track shipments" section in the dashboard menu; when clicked it displays your Transaction Count and Total value on the page`
                            },
                            {
                                description: `Here, you'll also see a list of your existing shipments, along with their respective order date, shipping ID, third party logistics, consignee, shipping costs, order status and payment status.`
                            },
                            {
                                description: `Click on the options icon to view, track, rate, manage or view shipping document for each shipment on the list`
                            },
                            {
                                description: `<strong>Search Shipments</strong>
                            You can search for your desired shipment by inserting the <strong>start date</strong> and <strong>end date</strong> you would 
                            like to make reference to through the search bar on the shippent list page`
                            },
                            {
                                description: `<strong>Filter Shipments</strong>
                            You can also filter the shipments according to their statuses
                            `
                            },
                        ]
                    },
                    {
                        title: "c) Get A Quote",
                        steps: [
                            {
                                description: `Navigate to the "Get Quote" button on the dashboard menu and click on it`
                            },
                            {
                                description: `A page that displays  your <strong>Document Count</strong>, a <strong>“Get New Quote”</strong> button with a list of the your documents `
                            },
                            {
                                description: `Click on the options icon to view, track, rate, manage or view shipping document for each shipment on the list`
                            },
                            {
                                description: `Click on “Get New Quote”  button`
                            },
                            {
                                description: `Fill the form that displays thereafter and Click on “Describe your shipment” button `
                            },
                        ]
                    },
                    {
                        title: "d) Manage Payments",
                        steps: [
                            {
                                description: `Card`
                            },
                            {
                                description: `Wallet `
                            },
                        ]
                    }
                ]
            }
        ],
        sectionNote: {
            description: `Congratulations! You are now equipped with the knowledge to effectively use the private customer dashboard of our logistics web app. If you have any further questions or need assistance, don't hesitate to reach out to our customer support team through the provided contact channels. Happy shipping!`
        }
    },
    {
        name: 'UserRating',
        path: '/user/rating',
        content: [
            {
                header: 'Ratings',
                description: `Here, you will be able to see what the dispatchers that have had an encounter with you think of you`,
                points: [{
                    title: null,
                    steps: [
                        {
                            description: `Step 1: Navigate to Ratings on the side navigation bar`
                        },
                        {
                            description: `Step 2: Click on Ratings and a list of ratings according to the 5 star metric system with the respective numbers of dispatchers that gave the ratings`
                        },
                    ]
                }]
            },
        ],
        sectionNote: { description: null }
    },
    {
        name: 'UserLocations',
        path: '/user/locations',
        content: [
            {
                header: 'LOCATION',
                description: `The “Location” menu item on the Private Customer Web Mulex app helps the customer manage 
                the addresses for either pick-ups or drop-offs of packages. The register shows all the available locations created by the user if any
                <br><br> To manage locations, customers need to follow the following steps:
                `,
                points: [
                    {
                        title: null,
                        steps: [
                            {
                                description: `Navigate to the MuleEx login interface via <a href="https://app.muleex.com/">https://app.muleex.com/</a>`
                            },
                            {
                                description: `Enter your Private Customer login credentials within the fields provided on the login page`
                            },
                            {
                                description: `Click on the “Locations” menu item.`
                            },
                            {
                                description: `Enter your Private Customer login credentials within the fields provided on the login page`
                            },
                            {
                                description: `The register displayed would show all the locations that have been created by the user thus far. Each entry in the record can either be edited, 
                        deleted or viewed on a map by the “Edit”, “Delete” and “View” actions respectively.                        `
                            },
                            {
                                description: `Users may also choose to search through their available locations on the register.`
                            },
                        ]
                    }]
            },
            {
                header: 'Creating a new location',
                description: `Users can create a new location on the app using the following steps: `,
                points: [
                    {
                        title: null,
                        steps: [
                            {
                                description: `Click on the location menu item on the side menu bar of the application`
                            },
                            {
                                description: `Click on the “Add” button.`
                            },
                            {
                                description: `Fill out the details form displayed in the modal and choose if the location to be created is a Shipping or a Destination location.`
                            },
                            {
                                description: `Click on the “Save” button.`
                            },
                        ]
                    }]
            },
        ],
        sectionNote: { description: null }
    },
    {
        name: 'ActiveBookings',
        path: '/active-bookings',
        content: [
            {
                header: 'Booking & Shipments',
                description: `This stands as a collection for all the customer’s active bookings, Quotes & Drafts and Booking History.`,
                points: [{
                    title: `Active Bookings`,
                    description: `Here you can book a new shipment, view all active bookings with their respective order date, shipping ID, its assigned third party logistics company, its consignee, total
                    shipping cost, order order cost, and payment status. <br><br>
                    Here are other terms and actions performed in Active Bookings section
                    `,
                    steps: [
                        {
                            description: `Transaction count: This stands for the total amount of transactions or bookings that the customer has initiated on the MuleEx platform.
                            `
                        },
                        {
                            description: `Total Value: This is the total amount of bookings or transactions that the user has initiated on the MuleEx platform.`
                        },
                        {
                            description: `Search bar: With this, you can search for a booking/ shipments with your preferred attribute/ characteristic`
                        },
                        {
                            description: `Start date and End date bars: You can search/ filter an order of yours according to its start date and end date `
                        }
                    ]
                }]
            },
        ],
        sectionNote: {
            description: null
        }
    },
    {
        name: 'QuoteAndDraft',
        path: '/quote-draft',
        content: [
            {
                header: 'Booking & Shipments',
                description: `Here, you can get a quick quote of a shipment, view the number of quote documents and a list of 
                previous quotes with their order date, shipping ID, its assigned third party
                 logistics company, its consignee, total shipping cost, order order cost, and payment status.`,
                points: [{
                    title: `Get New Quote`,
                    description: `Here you can book a new shipment, view all active bookings with their respective order date, shipping ID, its assigned third party logistics company, its consignee, total
                    shipping cost, order order cost, and payment status. <br><br>
                    Here are other terms and actions performed in Active Bookings section
                    `,
                    steps: [
                        {
                            description: `Navigate to the Booking and shipments section on the side nav`
                        },
                        {
                            description: `Click on Quotes and Drafts  then click on  “Get New Quote”`
                        },
                        {
                            description: `Fill the address on form for both the pickup and delivery locations`
                        },
                        {
                            description: `Click on Describe Your shipment button`
                        },
                        {
                            description: `Select your preferred shipment type, its dimensions weight and quantity `
                        },
                        {
                            description: `If you're not sure of its precise dimensions, then you can select an option that matches your shipment`
                        },
                        {
                            description: `Select your shipment category and even add another shipment if you want to`
                        },
                        {
                            description: `Select your preferred shipping option and fill in the declared value of package`
                        },
                        {
                            description: `Click “Get your quote” and a page of your quote will be displayed`
                        }
                    ]
                }]
            },
        ],
        sectionNote: {
            description: `Here, the list of your previous shipping orders with their respective order date, shipping ID, its assigned third party logistics company, its consignee, total shipping cost, order order cost, and payment status.`
        }
    },
    {
        name: 'HistoricalBookings',
        path: '/historical-bookings',
        content: [
            {
                header: 'Booking & Shipments',
                description: `Here, you can get a quick quote of a shipment, view the number of quote documents and a list of 
                previous quotes with their order date, shipping ID, its assigned third party
                 logistics company, its consignee, total shipping cost, order order cost, and payment status.`,
                points: [
                    {
                        title: `Shipping History`,
                        description: `Here, the list of your previous shipping orders with their respective order date, shipping ID, 
                        its assigned third party logistics company, its consignee, total shipping cost, order order cost, and payment status.`,
                    }
                ]
            },
        ],
        sectionNote: {
            description: null
        }
    },
    {
        name: 'PaymentsTransaction',
        path: '/payments/transaction',
        content: [
            {
                header: 'My Transactions',
                description: `This provides the user with topline analytics.that showcases the total transaction count,transaction statuses and total amount spent on booking requests initiated periodically.It also avails the user with the opportunity of viewing details of a specific transaction. In order to do this, follow the steps below:`,
            },
            {
                points: [{
                    steps: [
                        {
                            description: `Select My Transaction from the displayed dropdown (You should be routed to the Transaction screen).
                        `
                        },
                        {
                            description: `Navigate to the 3 dots on the right hand side and click on it (A dialog with the View action will be triggered on the screen)                        
                        `
                        },
                        {
                            description: `Finally, click on the View action (You should be routed to the detailed Transaction view)`
                        }
                    ]
                }]
            },
        ],
        sectionNote: {
            description: `This shows a comprehensive list of all wallet and card transactions initiated by the user. In order to see this, just select Account Statement from the Billings & Payment dropdown.`
        }
    },
    {
        name: 'UserDomain',
        path: '/user/analytic',
        content: [
            {
                header: 'ANALYTICS',
                description: `The analytics module of the Mulex Customer Web application gives the user a historical insight into the various activities that have occurred on the customer account. To use this module, take the following steps:`,
                points: [
                    {
                        title: "1)",
                        description: `Log in to the Mulex Customer web application with valid credentials.` 
                    },
                    {
                        title: "2)",
                        description: `Navigate to the Analytics module by clicking on the “Analytics” menu item on the sidebar menu of the application.`
                    },
                    {
                        title: "3)",
                        description: `The user is then directed to the Analytics page of the application.` 
                    }
                ]
            },
            {
                points: [
                    {
                        title: `MY SHIPMENT `,
                        description: `This gives an insight into the numeric values of the shipping activities made on the customer’s account. By default, the values in the analytics module are shown over a 30-day period. However, this can be adjusted to be viewed on a year-to-date and custom date range basis.`,
                    },
                    {
                        title: `RECENT SHIPMENTS`,
                        description: `This gives the customer a graphical insight into the status of his shipping activity as represented in a pie chart. Also, the values are shown on a 30-day basis but can be adjusted as the user desires.`,
                    },
                    {
                        title: `TOP DESTINATIONS`,
                        description: `This chart gives the user graphic data on the top destinations he has shipped to over a 30-day date period by default which can be customized.`,
                    },
                    {
                        title: `TOP PROVIDERS`,
                        description: `This analysis gives the user graphic data as to their top shipping provider over a 30-day period by default.`,
                    },
                ]
            },
        ],
        sectionNote: {
            description: null
        }
    },
]